import React from 'react'
        
import { NavIn3 } from '../components/componentNav/NavIn'
import { DinAllow } from '../components/componentHeader/Header'
import { GameSlash } from '../components/componentGoGame/GameSlash'
import { FooterAndButon } from '../components/componentFooter/Footer'

import '../style/Game.css'

export function Game() {
    
 window.scrollTo(0,0);
  return (
    <>
      <div className='backgroungGame'>
        <NavIn3 />
        <DinAllow />
        <GameSlash />
      </div>
     <FooterAndButon />
    </>
  )
}
